import $ from 'jquery';

var isTouchDevice = function () {
  if ('ontouchstart' in document.documentElement) {
    return true;
  } else {
    return false;
  }
};

var supportsLocalStorage = function () {
  try {
    return 'localStorage' in window && window['localStorage'] !== null;
  } catch (e) {
    return false;
  }
};

var supportsSmoothScroll = function () {
  if (document.documentElement.style.scrollBehavior === undefined) {
    return false;
  } else {
    return true;
  }
};

isTouchDevice() ? $('html').addClass('touch-device') : $('html').addClass('pointer-device');

export default {
  isTouchDevice,
  supportsLocalStorage,
  supportsSmoothScroll,
};
